export function vacanciesSlider() {

	if ($(window).width() <= '540') {
		$('.vacencies_list-items__js').slick({
			infinite: false,
			arrows: false,
			dots: true,
		});
	}
}